var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcConfirmationPgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send-A-Message-V5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.47754032,0 0,4.47915323 0,10 C0,15.5240726 4.47754032,20 10,20 C15.5224597,20 20,15.5240726 20,10 C20,4.47915323 15.5224597,0 10,0 Z M10,18.0645161 C5.54306452,18.0645161 1.93548387,14.4584274 1.93548387,10 C1.93548387,5.54455645 5.54322581,1.93548387 10,1.93548387 C14.4552823,1.93548387 18.0645161,5.54318548 18.0645161,10 C18.0645161,14.4568548 14.4584274,18.0645161 10,18.0645161 Z M10,4.43548387 C10.9353226,4.43548387 11.6935484,5.19370968 11.6935484,6.12903226 C11.6935484,7.06435484 10.9353226,7.82258065 10,7.82258065 C9.06467742,7.82258065 8.30645161,7.06435484 8.30645161,6.12903226 C8.30645161,5.19370968 9.06467742,4.43548387 10,4.43548387 Z M12.2580645,14.6774194 C12.2580645,14.9446371 12.0414113,15.1612903 11.7741935,15.1612903 L8.22580645,15.1612903 C7.95858871,15.1612903 7.74193548,14.9446371 7.74193548,14.6774194 L7.74193548,13.7096774 C7.74193548,13.4424597 7.95858871,13.2258065 8.22580645,13.2258065 L8.70967742,13.2258065 L8.70967742,10.6451613 L8.22580645,10.6451613 C7.95858871,10.6451613 7.74193548,10.4285081 7.74193548,10.1612903 L7.74193548,9.19354839 C7.74193548,8.92633065 7.95858871,8.70967742 8.22580645,8.70967742 L10.8064516,8.70967742 C11.0736694,8.70967742 11.2903226,8.92633065 11.2903226,9.19354839 L11.2903226,13.2258065 L11.7741935,13.2258065 C12.0414113,13.2258065 12.2580645,13.4424597 12.2580645,13.7096774 L12.2580645,14.6774194 Z",
    id: "ic_confirmation_pg_info",
    fill: "#A4ADB6",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConfirmationPgInfo);
export default __webpack_public_path__ + "static/media/ic_confirmation_pg_info.d796e1b0e58b349f82e7e07e14b409f3.svg";
export { ForwardRef as ReactComponent };